import { forwardRef, useRef } from "react";
import { clsx } from "clsx";

import { useMergedRefs } from "~/hooks/useMergedRefs";

import type { SyntheticEvent } from "react";

export interface TranscriptNodeProps {
  children: string;
  isSelected?: boolean;
  isCurrent?: boolean;
  scrollBehavior?: ScrollBehavior;
  onClick: () => void;
}

export const TranscriptNode = forwardRef<HTMLSpanElement, TranscriptNodeProps>(
  function TranscriptNodeImpl(
    { children, isCurrent, isSelected, scrollBehavior, onClick },
    ref,
  ) {
    const _ref = useRef<HTMLSpanElement>(null);
    const mergedRefs = useMergedRefs(ref, _ref);

    function handleMouseDown(e: SyntheticEvent) {
      _ref.current?.scrollIntoView({
        behavior: scrollBehavior,
        block: "center",
      });
      onClick?.();
    }

    return (
      <span
        ref={mergedRefs}
        className={clsx("TranscriptNode", {
          "TranscriptNode--selected": isSelected,
        })}
        aria-current={isCurrent}
        onMouseDown={handleMouseDown}
        dangerouslySetInnerHTML={{ __html: children }}
      />
    );
  },
);
